var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 510 510"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__e",
    x1: 155.409,
    x2: 211.535,
    y1: 77.091,
    y2: 133.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6fa953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43765a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__f",
    x1: 19.413,
    x2: 82.946,
    y1: 163.946,
    y2: 227.48,
    gradientTransform: "rotate(-45 210.446 234.29)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#vector_svg__a"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45a2e0"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__g",
    x1: 15.175,
    x2: 73.828,
    y1: 151.553,
    y2: 210.205,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#vector_svg__b"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__h",
    x1: 252.323,
    x2: 311.059,
    y1: 81.825,
    y2: 140.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffce47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9356"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__i",
    x1: 305.409,
    x2: 383.97,
    y1: 235.247,
    y2: 313.807,
    gradientTransform: "rotate(-45 210.446 234.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff755c"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__j",
    x1: 264.281,
    x2: 346.386,
    y1: 93.783,
    y2: 175.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__k",
    x1: 8.093,
    x2: 100.534,
    y1: 244.809,
    y2: 337.25,
    gradientTransform: "rotate(-45 210.446 234.29)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#vector_svg__b"
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__l",
    x1: 206.596,
    x2: 284.147,
    y1: 351.13,
    y2: 428.68,
    gradientTransform: "rotate(-45 210.446 234.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff755c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4181"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__m",
    x1: 293.327,
    x2: 262.928,
    y1: 437.86,
    y2: 407.461,
    gradientTransform: "rotate(-45 210.446 234.29)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#843561"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__n",
    x1: 74.219,
    x2: 261.743,
    y1: 310.934,
    y2: 498.458,
    gradientTransform: "rotate(-45 210.446 234.29)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#vector_svg__a"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#843561",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2156,
    stopColor: "#6c335b",
    stopOpacity: 0.216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5241,
    stopColor: "#513153",
    stopOpacity: 0.524
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7959,
    stopColor: "#402f4f",
    stopOpacity: 0.796
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a2f4d"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__o",
    x1: 355.785,
    x2: 355.785,
    y1: 170.248,
    y2: 244.994,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#vector_svg__c"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__p",
    x1: 69.381,
    x2: 76.357,
    y1: 237.228,
    y2: 311.968,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#vector_svg__c"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__q",
    x1: 110.157,
    x2: 385.409,
    y1: 204.922,
    y2: 480.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c7e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7acbff"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7acbff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2f73a0"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__r",
    x1: 216.324,
    x2: 393.419,
    y1: 241.074,
    y2: 205.064,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#vector_svg__d"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__s",
    x1: 252.205,
    x2: 252.205,
    y1: 437.482,
    y2: 505.958,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#vector_svg__d"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "vector_svg__t",
    x1: 118.688,
    x2: 177.938,
    y1: 245.067,
    y2: 304.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c7e9ff",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__e)",
    d: "M214.696 29.03v119.267c-24.426 0-48.851 9.315-67.482 27.946l-84.331-84.33c41.92-41.92 96.867-62.891 151.813-62.883z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__f)",
    d: "M119.268 243.726c0 24.426 9.315 48.851 27.946 67.482l-84.331 84.331C20.964 353.619-.007 298.673 0 243.726z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__g)",
    d: "M62.883 91.913l84.331 84.331c-18.631 18.631-27.946 43.057-27.946 67.482H0c-.007-54.947 20.964-109.893 62.883-151.813z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__h)",
    d: "M366.509 91.913l-84.331 84.331c-18.631-18.631-43.057-27.946-67.482-27.946V29.031c54.947-.009 109.894 20.962 151.813 62.882z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__i)",
    d: "M366.509 91.913c41.92 41.92 62.891 96.866 62.883 151.813H310.125c0-24.426-9.315-48.851-27.946-67.482z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__j)",
    d: "M366.509 91.913c41.92 41.92 62.891 96.866 62.883 151.813H310.125c0-24.426-9.315-48.851-27.946-67.482z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__k)",
    d: "M214.696 339.155v119.267c-54.947.007-109.893-20.963-151.813-62.883l84.331-84.331c18.631 18.631 43.057 27.947 67.482 27.947z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__l)",
    d: "M429.392 243.726c.007 54.947-20.963 109.893-62.883 151.813l-84.331-84.331c18.631-18.631 27.946-43.057 27.946-67.482z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__m)",
    d: "M429.392 243.726c.007 54.947-20.963 109.893-62.883 151.813l-84.331-84.331c18.631-18.631 27.946-43.057 27.946-67.482z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__n)",
    d: "M282.178 311.208l84.331 84.331c-41.92 41.92-96.866 62.891-151.813 62.883V339.155c24.426 0 48.851-9.316 67.482-27.947z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__o)",
    d: "M282.178 176.244c18.631 18.631 27.946 43.057 27.946 67.482h119.268c.004-28.417-5.618-56.828-16.832-83.443H298.139z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__p)",
    d: "M1.311 220.075A215.925 215.925 0 000 243.726c-.007 54.947 20.963 109.893 62.883 151.813l84.331-84.331c-18.631-18.631-27.947-43.057-27.947-67.482a95.82 95.82 0 012.98-23.651z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__q)",
    d: "M369.706 200.381c-15.21 0-29.85 2.43-43.566 6.907-14.67-47.862-59.206-82.665-111.874-82.665-64.616 0-116.997 52.381-116.997 116.997 0 9.336 1.1 18.415 3.166 27.119-55.143 3.887-98.672 49.847-98.672 105.98 0 58.681 47.57 106.252 106.252 106.252h261.691C447.188 480.97 510 418.158 510 340.676s-62.812-140.295-140.294-140.295z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__r)",
    d: "M229.408 340.681c0 5.691.342 11.299 1.004 16.812a115.685 115.685 0 01-16.151 1.122c-64.616 0-116.989-52.385-116.989-117.001 0-64.604 52.373-116.989 116.989-116.989 52.668 0 97.213 34.805 111.877 82.668-56.151 18.312-96.73 71.11-96.73 133.388z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vector_svg__s)",
    d: "M2.581 387.944c6.511 52.439 51.231 93.026 105.433 93.026h261.691c60.895 0 112.721-38.801 132.123-93.026z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 188.092,
    cy: 315.131,
    r: 86.255,
    fill: "url(#vector_svg__t)"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgVector as ReactComponent };